// extracted by mini-css-extract-plugin
var _1 = "ra-follow-btn";
var _2 = "ra-follow-btn-icon";
var _3 = "ra-follow-btn-light";
export { _1 as "followBtnCls", _2 as "followBtnIconCls", _3 as "followBtnLightCls" }
